import React from 'react';

import { clsx } from 'clsx';

import styles from './RatingButton.module.scss';

interface Props {
    rating: RatingType;
    handleClick: (rating: RatingType) => void;
    selected: boolean;
    buttonClass?: string;
    buttonTextClass?: string;
}

export type RatingType = { value: string; label: string };

export const RatingButton = (props: Props) => {
    const { rating, handleClick, selected, buttonClass, buttonTextClass } = props;

    const buttonClassName = clsx(
        styles.ratingButton,
        buttonClass !== undefined ? buttonClass : '', // Because Terser doesn't support optional chaining
        selected && styles.ratingButtonSelected
    );

    const textClassName = clsx(
        styles.ratingButtonText,
        buttonTextClass !== undefined ? buttonTextClass : '' // Because Terser doesn't support optional chaining
    );

    return (
        <button onClick={() => handleClick(rating)} className={buttonClassName}>
            <span className={textClassName}>
                {rating.label}
            </span>
        </button>
    );
};
